import script from "./DataTableFacetFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataTableFacetFilter.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__